/**
 * Public-facing location string for a listing.
 *
 * Listings store the seller's full pickup address in privateData (only the
 * seller can read it). publicData.location carries `{ city, state, zipcode }`,
 * the most specific identifier we'll ever show without an active
 * transaction. Legacy listings (created before the fuzzy-location split)
 * may instead carry `publicData.location.address` (full street string);
 * those are returned as-is so they don't break the UI until they're edited
 * and migrated to the new shape.
 *
 * @param {Object|undefined} location - The publicData.location object
 * @returns {string} A display string like "Buffalo, NY 14201" or "" if unknown
 */
export const formatPublicLocation = location => {
  if (!location) return '';
  const { city, state, zipcode, address } = location;
  if (city || state) return [city, state].filter(Boolean).join(', ');
  if (zipcode) return zipcode;
  return address || '';
};
